import fontColorContrast from "better-font-color-contrast";
import Quill from "quill";

import { ColorType } from "./ColorPicker";

export const getFormat = (editor: Quill) => {
  const selection = editor.getSelection();
  const index = selection ? selection.index : 0;
  const length = selection ? selection.length : 0;
  const format = editor.getFormat(index, length);

  return { format, index, length };
};

export const formatTextSelection = (editor: Quill, format: "background" | "color", color: ColorType) => {
  const { index, length } = getFormat(editor);
  editor.formatText(index, length, format, color);
};

export const setContrastColor = (editor: Quill) => {
  const {
    format: { background },
    index,
    length,
  } = getFormat(editor);
  const textColor = fontColorContrast(background as string);

  editor.formatText(index, length, "color", background ? textColor : false);
};
